// extracted by mini-css-extract-plugin
export default {"live_desc":"index_live_desc__sHAPQ","icon":"index_icon__wq9Hv","text":"index_text__oYR6U"};